import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { setSelectedElementIds } from 'crazyEditor/redux/modules/stage/stage';
import reactMixin from 'react-mixin';
import styles from './LassoStyles';
import { getElementsWithinRect } from '../MouseCatcherUtils';

function getNormalizedDimensions(x, y, width, height) {
  const mathAbsWidth = Math.abs(width);
  const mathAbsHeight = Math.abs(height);
  return {
    normalizedX: width > 0 ? x : x - mathAbsWidth,
    normalizedY: height > 0 ? y : y - mathAbsHeight,
    mathAbsWidth: mathAbsWidth,
    mathAbsHeight: mathAbsHeight
  };
}

@connect(
  false,
  {setSelectedElementIds}
)
@Radium
export default class Lasso extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...getNormalizedDimensions(props.x, props.y, props.width, props.height),
      potentialElements: []
    };
  }

  componentWillReceiveProps(nextProps) {
    const { elements, x, y, width, height } = nextProps;
    const { normalizedX, normalizedY, mathAbsWidth, mathAbsHeight } = this.state;
    const potentialElements = getElementsWithinRect(elements, normalizedX, normalizedY, mathAbsWidth, mathAbsHeight);

    this.setState({
      ...getNormalizedDimensions(x, y, width, height),
      potentialElements: potentialElements
    });
  }

  componentWillUnmount() {
    const { setSelectedElementIds } = this.props;
    const { potentialElements } = this.state;
    if (potentialElements.length) {
      setSelectedElementIds(potentialElements.map((potentialElement) => potentialElement.id));
    }
  }

  render() {
    const { potentialElements, normalizedX, normalizedY, mathAbsWidth, mathAbsHeight } = this.state;
    return (
      <div style={styles.lassoContainer}>
        <svg style={styles.lassoSvgContainer}>
          <rect x={normalizedX}
                y={normalizedY - this.props.stageLayoutTop}
                width={mathAbsWidth}
                height={mathAbsHeight}
                style={styles.lassoRect}
          />
          {potentialElements.map((potentialElement, ind) =>
            (<rect x={potentialElement.absLayout.x}
                   y={potentialElement.absLayout.y}
                   width={potentialElement.layout.width}
                   height={potentialElement.layout.height}
                   style={styles.lassoPotentialElement}
                   key={`potentialElement${ind}`}
                   {...styles.lassoPotentialElementProps}
            />))
          }

        </svg>
      </div>
    );
  }
}

Lasso.propTypes = {
  elements: PropTypes.object.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  stageLayoutTop: PropTypes.number.isRequired
};